module.exports = __webpack_public_path__ + "static/img/zz_la.7445db6e.png";